module.exports = __webpack_public_path__ + "static/media/success.26a7e02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/springImage/success.png
// module id = 966
// module chunks = 0